<template>
    <div class="summary-view view">
        <instructions titleKey="summary" property="summaryHelpContent" />

        <worktop-drawing v-if="state.mode == 'worktop'" :editableFields="[ 'summary', 'sinkDistanceFront', 'hobcutoutDistanceFront' ]" />

        <backpanel-drawing v-if="state.mode == 'backpanel'" />

        <div class="drawing-container drawing-placeholder" v-if="state.mode == ''">
            <div class="wrapper"></div>
        </div>

        <div class="wrapper">
            <div class="loading" v-if="cart.products.length == 0">
            </div>
            <div class="section-content" v-if="cart.products.length > 0">
                <div class="row">
                    <div class="col-8">
                        <h2 class="h2" v-html="ui.t('summaryTitle')"></h2>

                        <template v-if="!state.externalEmbed">
                            <div class="html-text" v-html="ui.texts.summaryTopText.text" />

                            <a href="#" class="add-product" @click.prevent="addNewProductPopupVisible = true" v-html="ui.t('addNewProduct')"></a>
                        </template>

                        <table class="cart-products">
                            <thead>
                                <tr>
                                    <th v-html="ui.t('product')"></th>
                                    <th v-if="!ui.isTabletView" v-html="ui.t('dimensions')"></th>
                                    <th v-if="!ui.isTabletView" class="tablet-hidden" v-html="ui.t('productCode')"></th>
                                    <th class="price" v-if="!ui.hidePrices && !state.prodlib" v-html="ui.t('rRP')"></th>
                                    <th></th>
                                </tr>
                            </thead>

                            <tbody v-for="cartProduct in cart.products" :key="cartProduct.code">
                                <tr class="cartproduct" @click="setCurrentPlan(cartProduct.code)" :class="{ active: cartProduct.code == selectedPlan }">
                                    <td>
                                        {{ cartProduct.name }}

                                        <template v-if="ui.isTabletView">
                                            <br/>
                                            {{ cartProduct.dimensions }}
                                            <br />
                                            {{ cartProduct.code }}
                                        </template>
                                    </td>
                                    <td v-if="!ui.isTabletView">{{ cartProduct.dimensions }}</td>
                                    <td v-if="!ui.isTabletView" class="code">
                                        <span v-if="!cart.isAdditionalCostProduct(cartProduct.code)">
                                            {{ cartProduct.code }}
                                        </span>
                                    </td>
                                    <td v-if="!ui.hidePrices && !state.prodlib" class="price">
                                        <span v-if="cartProduct.price! > 0">
                                            {{ cartProduct.price!.toFixed(cart.numberOfDecimals) }} {{ cart.currencyCode }}
                                        </span>
                                    </td>
                                    <td><a href="#" v-if="cartProduct.removable && !state.externalEmbed" @click.prevent="removeProduct(cartProduct)" class="icon-trash-o"></a></td>
                                </tr>

                                <template v-if="cartProduct.accessories!.length > 0">
                                    <tr class="compact accessory" v-for="accessory in cartProduct.accessories" :key="accessory.code">
                                        <td>{{ accessory.name }}</td>
                                        <td v-if="!ui.isTabletView">{{ accessory.dimensions }}</td>
                                        <td v-if="!ui.isTabletView" class="code">
                                            <span v-if="accessory.code != 'trap'">
                                                {{ accessory.code }}
                                            </span>
                                        </td>
                                        <td v-if="!ui.hidePrices && !state.prodlib" class="price">
                                            <span v-if="accessory.price! > 0">
                                                {{ accessory.price!.toFixed(cart.numberOfDecimals) }} {{ cart.currencyCode }}
                                            </span>
                                        </td>
                                        <td><a @click.prevent="cart.removeAccessoryProductFromCart(cartProduct, accessory)"  href="#" class="icon-trash-o"></a></td>
                                    </tr>
                                </template>
                            </tbody>

                            <tbody class="summary" v-if="cart.priceSummary && !ui.hidePrices && !state.prodlib">
                                <tr>
                                    <td :colspan="summaryColumnRowSpan" v-html="ui.t('totalNoTax')"></td>
                                    <td class="price">{{ cart.priceSummary.subTotal.toFixed(cart.numberOfDecimals) }} {{ cart.currencyCode }}</td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td :colspan="summaryColumnRowSpan" v-html="ui.t('taxTotal') + ' ' + cart.taxPercent + '%'"></td>
                                    <td class="price">{{ cart.priceSummary.tax.toFixed(cart.numberOfDecimals) }} {{ cart.currencyCode }}</td>
                                    <td></td>
                                </tr>
                            </tbody>
                            <tbody class="grand-total" v-if="cart.priceSummary && !ui.hidePrices && !state.prodlib">
                                <tr>
                                    <td :colspan="summaryColumnRowSpan - 1" v-html="ui.t('grandTotal') + ' ' + cart.taxPercent + '%'"></td>
                                    <td>
                                        <span v-if="cart.hasBackpanelsInCart" v-html="ui.t('backpanelPriceNotice')"></span>
                                    </td>
                                    <td class="price">{{ cart.priceSummary.grandTotal.toFixed(cart.numberOfDecimals) }} {{ cart.currencyCode }}</td>
                                    <td></td>
                                </tr>
                            </tbody>
                        </table>

                        <div class="html-text" v-if="!state.externalEmbed" v-html="ui.texts.summaryTextContent.text"></div>
                    </div>

                    <div class="col-4">
                        <div v-if="!state.store">
                            <h2 class="h2" v-html="ui.t('planCode')"></h2>

                            <label class="form-group plan-code">
                                <div class="row">
                                    <div class="col-12">
                                        <input type="text" ref="planCode" @click.prevent="copyCode" readonly v-model="cart.planCode" class="form-control" />

                                        <span class="input-tip" v-if="codeWasCopied" v-html="ui.t('codeWasCopied')"></span>
                                    </div>
                                    <!-- <div class="col-4">
                                        <a href="#" class="button-link" @click.prevent="copyCode" v-html="ui.t('copyPlanCode')"></a>
                                    </div> -->
                                </div>
                            </label>
                        </div>

                        <h2 class="h2" v-if="state.prodlib == false" v-html="ui.t('summaryActions')"></h2>

                        <div class="summary-actions" v-if="state.prodlib == false">
                            <a href="#" class="button-link green" v-if="(!state.isProshopUser && !state.externalEmbed) || state.store" @click.prevent="addToStoreCart" v-html="ui.t('addToCart')"></a>

                            <a href="#" class="button-link green" v-if="state.fusion" @click.prevent="sendToFusion" v-html="ui.t('addProductToFusion')"></a>

                            <a href="#" class="button-link blue" v-if="state.isProshopUser && !state.externalEmbed" @click.prevent="addToProshopFavorites" v-html="ui.t('saveToProshopFavorites')"></a>
                            <a href="#" class="button-link blue" v-if="state.isProshopUser && !state.externalEmbed" @click.prevent="addToProshopCart" v-html="ui.t('addToProshopCart')"></a>

                            <a :href="pdfLink" class="button-link gray" @click="trackSavePdf" target="_blank" v-html="ui.t('savePdf')"></a>
                            <a href="#" class="button-link gray" @click.prevent="sendEmailPopupVisible = true" v-html="ui.t('sendEmail')" v-if="!state.externalEmbed"></a>                                                        

                            <div v-if="state.vertex" class="button-container">
                                <input type="text" ref="vertexCode" id="yhteenvetoKoodiID" name="yhteenvetoKoodiID" v-model="vertexCode" class="form-control-hidden" />

                                <span class="input-tip" v-if="false && codeWasSentToVertex" v-html="ui.t('codeWasAddedToVertex')"></span>
                                <a href="#" class="button-link" v-if="false"  @click.prevent="sendToVertex" v-html="ui.t('addProductToVertex')"></a>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- <h1>Koodi: {{ cart.currentDesignerCode }}, Koodi on toimiva: {{ cart.validCode ? "Kyllä" : "Ei" }}</h1> -->

                <!-- <div class="state-debug" v-html="stateDetails"></div> -->

                <!-- <div class="cart-debug" v-if="codeSummary.length > 0">
                    <p v-for="part in codeSummary" :key="part">
                        {{ part }}
                    </p>
                </div> -->
            </div>
        </div>


        <popup v-model:visible="addToFavoritesPopupVisible" class="add-to-cart">
            <h2 class="h2" v-html="ui.t('saveToProshopFavorites')"></h2>

            <div class="error" v-if="!addedToFavorites" v-html="getCartFailureMessage()"></div>

            <div class="success" v-if="addedToFavorites" v-html="ui.t('addedToFavoritesSuccessText')"></div>
        </popup>

        <popup v-model:visible="addToCartPopupVisible" class="add-to-cart">
            <h2 class="h2" v-html="ui.t('addToProshopCart')"></h2>

            <div class="error" v-if="!addedToCart" v-html="getCartFailureMessage()"></div>

            <div class="success" v-if="addedToCart" v-html="ui.t('addedToCartSuccessText')"></div>
        </popup>

        <popup v-model:visible="addNewProductPopupVisible" class="add-new-product">
            <h2 class="h2" v-html="ui.t('addNewProduct')"></h2>

            <a href="#" class="button-link" @click.prevent="addWorktop" v-html="ui.t('worktop')"></a>
            <a href="#" class="button-link" @click.prevent="addBackpanel" v-html="ui.t('backpanel')"></a>
        </popup>

        <popup v-model:visible="sendEmailPopupVisible" class="email">
            <h2 class="h2" v-html="ui.t('sendEmail')"></h2>

            <div class="loading" v-if="sendingEmail"></div>

            <div class="email-form" v-if="!emailSent && !errorSendingEmail">
                <div class="row">
                    <div class="col-6">
                        <label class="form-group big">
                            <input type="text" v-model="emailSenderName" :class="{ invalid: invalidEmailSender }" :placeholder="ui.t('emailSenderName')" maxlength="100" class="form-control"  />
                        </label>
                    </div>

                    <div class="col-6">
                        <label class="form-group big">
                            <input type="text" :placeholder="ui.t('emailRecipient')" :class="{ invalid: invalidEmailRecipient }" maxlength="200" v-model="emailRecipient" class="form-control"  />
                        </label>
                    </div>
                </div>

                <div class="row" v-if="emailShowOrderFields">
                    <div class="col-6">
                        <label class="form-group big">
                            <input type="text" v-model="emailOrderName" :placeholder="ui.t('emailOrderName')" :class="{ invalid: invalidEmailOrderName }" maxlength="100" class="form-control"  />
                        </label>
                    </div>

                    <div class="col-6">
                        <label class="form-group big">
                            <input type="text"  v-model="emailOrderNumber" :placeholder="ui.t('emailOrderNumber')" :class="{ invalid: invalidEmailOrderNumber }" maxlength="200" class="form-control"  />
                        </label>
                    </div>
                </div>

                <div class="row" v-if="emailShowOrderFields">
                    <div class="col-6">
                        <label class="form-group big">
                            <input type="text" v-model="emailOrderDeliveryDate" :placeholder="ui.t('emailOrderDeliveryDate')" :class="{ invalid: invalidEmailOrderDeliveryDate }" maxlength="100" class="form-control"  />
                        </label>
                    </div>
                </div>

                <label class="form-group big">
                    <textarea v-model="emailMessage" :placeholder="ui.t('emailMessage')" maxlength="400" class="form-control"  />
                </label>

                <div class="error" v-if="sendingEmailThrottled" v-html="ui.t('sendingEmailsThrottled')"></div>

                <div class="submit">
                    <a href="#" class="button-link" @click.prevent="sendEmail" v-html="ui.t('send')"></a>
                </div>
            </div>

            <div class="error" v-if="errorSendingEmail" v-html="ui.t('errorSendingEmail')"></div>

            <div class="success" v-if="emailSent" v-html="ui.texts.emailSentTextContent.text"></div>
        </popup>

        <div class="navigation">
            <div class="wrapper">
                <router-link :to="backLink" v-html="ui.t('previous')" />
                <router-link to="/thankyou" class="exit-designer" :class="{ disabled: !ui.hobcutoutSelectionsComplete && !ui.backpanelSelectionsComplete }" v-if="!state.externalEmbed" v-html="ui.t('exitDesigner')" />
            </div>
        </div>
    </div>
</template>

<script async setup lang="ts">
import { computed, ref, useTemplateRef, watch, type Ref } from 'vue';
import { useCart, useConfiguration, useState, useUI } from '../store';
import { onBeforeRouteLeave, useRouter } from 'vue-router';
import type { AddToCartResponse, CartProduct } from '../models';
import axios from 'axios';
import { event } from "vue-gtag";

const addedToCart: Ref<boolean | null> = ref(null);
const addToCartFailedProducts: Ref<string[]> = ref([]);
const addingToCart = ref(false);
const addToCartPopupVisible = ref(false);
const addToFavoritesPopupVisible = ref(false);

const codeWasCopied = ref(false);
let codeWasCopiedTimer: number | null = null;

const codeWasSentToVertex = ref(false);
let codeWasSentToVertexTimer: number | null = null;

const addingToFavorites = ref(false);
const addedToFavorites: Ref<boolean | null> = ref(null);

const sendEmailPopupVisible = ref(false);

const addNewProductPopupVisible = ref(false);

const emailSenderName: Ref<string | null> = ref(null);
const emailRecipient: Ref<string | null> = ref(null);
const emailMessage: Ref<string | null> = ref(null);
const emailOrderName: Ref<string | null> = ref(null);
const emailOrderNumber: Ref<string | null> = ref(null);
const emailOrderDeliveryDate: Ref<string | null> = ref(null);

const invalidEmailSender = ref(false);
const invalidEmailRecipient = ref(false);

const emailSent = ref(false);
const errorSendingEmail = ref(false);
const sendingEmailThrottled = ref(false);

const sendingEmail = ref(false);

const isProshopUser = ref(false);

const codeIndex = ref(0);

const { cart } = useCart();
const { ui } = useUI();
const { state } = useState();
const { configuration } = useConfiguration();
const router = useRouter();

const vertexCodeRef = useTemplateRef("vertexCode");
const planCodeRef = useTemplateRef("planCode");

const selectedPlan: Ref<string | null> = ref(null);

async function removeProduct(product: CartProduct) {
    if (!confirm(ui.t("removeProductConfirm")))
        return;

    await cart.removeProductFromCart(product);

    if (cart.cartProducts.length == 0) {
        router.push("/");
    }
}

async function addProduct() {
    await cart.addCurrentDesignToCart();

    cart.resetState();
}

async function addWorktop() {
    await addProduct();

    router.replace(state.allowNewDesigner ? "/family" : "/worktop");
}

async function addBackpanel() {
    await addProduct();

    router.replace("/backpanel");
}

async function setCurrentPlan(code: string) {
    // If designer holds currently selected plan, do nothing
    if (selectedPlan.value == code)
        return;
    
    // If current plan is not in cart yet, add it
    if (!cart.cartProducts.some(p => p.code == cart.currentDesignerCode)) {
        await cart.addCurrentDesignToCart();
    }

    // Add all listed products not in cart yet
    for(const prod of cart.products.filter(p => !cart.cartProducts.some(cp => cp.code == p.code || cp.code == code))) {
        cart.cartProducts.push({...prod, removable: true });
    }

    // Remove selected product from cart as it will be added again when returning to summary
    cart.cartProducts.splice(cart.cartProducts.findIndex(cp => cp.code == code), 1);

    await cart.resetState();
    await cart.fillState(code);
    selectedPlan.value = code;
}

async function mounted() {
    selectedPlan.value = cart.currentDesignerCode;

    await cart.populateSummary();
    await trackDesign();

    if (!selectedPlan.value)
        selectedPlan.value = cart.products.length ? cart.products[0].code : null;

    if (window.parent?.postMessage)
        await window.parent.postMessage({
            type: "planCode",
            planCode: cart.planCode
        }, "*")
}

watch(() => sendEmailPopupVisible, popupVisibilitychanged);

async function trackDesign() {
    var bodyFormData = new FormData();

    bodyFormData.append("Code", cart.planCode!);
    bodyFormData.append("IsProshopUser", state.isProshopUser.toString());
    bodyFormData.append("IsProshop", state.proshop.toString());
    bodyFormData.append("IsFusion", state.fusion.toString());
    bodyFormData.append("IsVertex", state.vertex.toString());

    await axios.post<boolean>(
        "LogDesign",
        bodyFormData,
        { headers: {'Content-Type': 'multipart/form-data' } }
    );
}

const vertexCode = computed(() => {
    let product = cart.products[0];

    let code = product.code;

    if (!state.disableAccessories && state.accessories && state.accessories.length > 0) {
        let accessories = state.accessories.filter(a => a != "trap");

        if (accessories && accessories.length > 0)
            code += "|" + accessories.reduce((a, s) => a + "|" + s);
    }

    return code;
});

function trackSavePdf() {
    // if (!$ga)
    //     return;

    // $ga.event({
    //     eventCategory: 'DesignerAction',
    //     eventAction: 'savePdf',
    //     eventLabel: cart.planCode,
    //     eventValue: 1
    // });

    event("savePdf", {
       "event_category": "DesignerAction",
       "event_label": cart.planCode,
       "value": 1
    });
}

function sendToVertex() {
    var codeInput = vertexCodeRef.value as HTMLInputElement;

    codeInput.select();

    document.execCommand("copy");

    window.getSelection()!.removeAllRanges();

    codeWasSentToVertex.value = true;

    clearTimeout(codeWasSentToVertexTimer!);

    codeWasSentToVertexTimer = setTimeout(() => codeWasSentToVertex.value = false, 3000);
}

function sendToFusion() {
    let product = cart.products[0];
    let planCode = cart.planCode == product.code ? "" : cart.planCode;
    let accessories = product.accessories && product.accessories.length > 0
        ? product.accessories.map(a => { return a.code }).filter(a => a != "trap").join(",")
        : "";

    (window.external as any).UtilizeCodeAndPrice(product.code, product.price!.toString(), planCode, accessories);

    event("sendToFusion", {
       "event_category": "DesignerAction",
       "event_label": cart.planCode,
       "value": 1
    });

    // if ($ga) {
    //     $ga.event({
    //         eventCategory: 'DesignerAction',
    //         eventAction: 'sendToFusion',
    //         eventLabel: cart.planCode,
    //         eventValue: 1
    //     });
    // }
}

function popupVisibilitychanged() {
    if (!sendEmailPopupVisible) {
        emailSent.value = false;
        errorSendingEmail.value = false;
        sendingEmailThrottled.value = false;
    }
}

// const vertexCode = computed(() => {


const summaryColumnRowSpan = computed(() => {
    return ui.isTabletView ? 1 : 3;
});

const emailShowOrderFields = computed(() => {
    return emailRecipient && emailRecipient.value && emailRecipient.value.trim().endsWith("@stala.com");
});

const stateDetails = computed(() => {
    let properties = "";

    for (let stateProperty in state) {
        properties += stateProperty + ":" + state[stateProperty] + "<br />";
    }

    return properties;
});

const backLink = computed(() => {
    if (state.mode == "backpanel")
        return "backpanel-material";

    return state.disableAccessories
        ? `${state.productFamily}/hobcutout`
        : `${state.productFamily}/accessories`;
});

function copyCode() {
    var codeInput = planCodeRef.value as HTMLInputElement;

    codeInput.select();

    document.execCommand("copy");

    window.getSelection()!.removeAllRanges();

    if (state.vertex)
        return;

    codeWasCopied.value = true;

    clearTimeout(codeWasCopiedTimer!);

    codeWasCopiedTimer = setTimeout(() => codeWasCopied.value = false, 3000);
}

const pdfLink = computed(() => {
    return "/designer/pdf/?planCode=" + cart.planCode + "&language=" + ui.language;
});

function getCartFailureMessage() {
    return ui.t('addedToCartFailedText')
        + " "
        + (addToCartFailedProducts && addToCartFailedProducts.value.length > 0 ? addToCartFailedProducts.value.reduce((acc, p) => acc + "," + p) : "");
}

async function addToProshopFavorites() {
    if (addingToFavorites.value)
        return;

    var bodyFormData = new FormData();

    bodyFormData.append("planCode", cart.planCode!);

    addingToFavorites.value = true;

    await axios.post<boolean>(
        "AddPlanToFavorites",
        bodyFormData,
        { headers: {'Content-Type': 'multipart/form-data' } }
    ).then(response => {
        addedToFavorites.value = response.data;
        addingToFavorites.value = false;

        addToFavoritesPopupVisible.value = true;

        event("addToFavorites", {
            "event_category": "DesignerAction",
            "event_label": cart.planCode,
            "value": 1
        });

        // if ($ga) {
        //     $ga.event({
        //         eventCategory: 'DesignerAction',
        //         eventAction: 'addToFavorites',
        //         eventLabel: cart.planCode,
        //         eventValue: 1
        //     });
        // }
    }
    ).catch(error => {
        addedToFavorites.value = false;

        addingToFavorites.value = false;

        addToFavoritesPopupVisible.value = true;
    });
}

const invalidEmailOrderName = computed(() => {
    return !emailOrderName || !emailShowOrderFields;
});

const invalidEmailOrderNumber = computed(() => {
    return !emailOrderNumber || !emailShowOrderFields;
});

const invalidEmailOrderDeliveryDate = computed(() => {
    return !emailOrderDeliveryDate || !emailShowOrderFields;
});

async function addToStoreCart() {
    if (addingToCart.value)
        return;

    let addToCartFailedProducts = [];

    var bodyFormData = new FormData();

    bodyFormData.append("planCode", cart.planCode!);
    bodyFormData.append("language", ui.language);

    addingToCart.value = true;

    await axios.post<AddToCartResponse>(
        "AddPlanToStoreCart",
        bodyFormData,
        { headers: {'Content-Type': 'multipart/form-data' } }
    ).then(response => {
        addedToCart.value = response.data.success;
        addToCartFailedProducts = response.data.failedProducts;
        addingToCart.value = false;

        addToCartPopupVisible.value = true;

        event("addToCart", {
            "event_category": "DesignerAction",
            "event_label": cart.planCode,
            "value": 1
        });

        // if ($ga) {
        //     $ga.event({
        //         eventCategory: 'DesignerAction',
        //         eventAction: 'addToCart',
        //         eventLabel: cart.planCode,
        //         eventValue: 1
        //     });
        // }

        if (window.parent) {
            window.parent.postMessage("cartRefresh", "*");
        }
        
        if ((!window.parent || window.parent == window) && configuration.checkoutUrl) {
            ui.exitConfirmed = true;
            state.dirty = false;

            window.location.href = configuration.checkoutUrl;
        }

    }
    ).catch(error => {
        addedToCart.value = false;

        addingToCart.value = false;

        addToCartPopupVisible.value = true;
    });
}

async function addToProshopCart() {
    if (addingToCart.value)
        return;

    let addToCartFailedProducts = [];

    var bodyFormData = new FormData();

    bodyFormData.append("planCode", cart.planCode!);

    addingToCart.value = true;

    await axios.post<AddToCartResponse>(
        "AddPlanToCart",
        bodyFormData,
        { headers: {'Content-Type': 'multipart/form-data' } }
    ).then(response => {
        addedToCart.value = response.data.success;
        addToCartFailedProducts = response.data.failedProducts;
        addingToCart.value = false;

        addToCartPopupVisible.value = true;

        event("addToCart", {
            "event_category": "DesignerAction",
            "event_label": cart.planCode,
            "value": 1
        });

        // if ($ga) {
        //     $ga.event({
        //         eventCategory: 'DesignerAction',
        //         eventAction: 'addToCart',
        //         eventLabel: cart.planCode,
        //         eventValue: 1
        //     });
        // }

        if (window.parent) {
            window.parent.postMessage("cartRefresh", "*");
        }
    }
    ).catch(error => {
        addedToCart.value = false;

        addingToCart.value = false;

        addToCartPopupVisible.value = true;
    });
}

async function sendEmail() {
    if (sendingEmail.value)
        return;

    sendingEmail.value = true;

    let emailRegexp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);

    // if (!emailSenderName) {
    //     invalidEmailSender.value = true;

    //     sendingEmail.value = false;

    //     return;
    // }

    invalidEmailSender.value = false;

    let isValidEmailAddress = emailRegexp.test(emailRecipient.value!);

    if (!isValidEmailAddress) {
        invalidEmailRecipient.value = true;

        sendingEmail.value = false;

        return;
    }

    if (emailShowOrderFields.value) {
        let requiredFields = [ emailOrderName.value, emailOrderNumber.value, emailOrderDeliveryDate.value ];

        if(requiredFields.filter(f => !f || f.length <= 0).length > 0) {
            sendingEmail.value = false;

            return;
        }
    }

    invalidEmailRecipient.value = false;

    let verificationToken = document.querySelector('input[name="__RequestVerificationToken"]') as HTMLInputElement;

    var bodyFormData = new FormData();

    if (emailSenderName.value)
        bodyFormData.append("sender", emailSenderName.value);

    if (emailMessage.value)
        bodyFormData.append("message", emailMessage.value);

    bodyFormData.append("email", emailRecipient.value!);
    bodyFormData.append("code", cart.planCode!);
    bodyFormData.append("__RequestVerificationToken", verificationToken.value);

    if (emailShowOrderFields.value) {
        if (emailOrderName.value)
            bodyFormData.append("orderName", emailOrderName.value);
        if (emailOrderNumber.value)
            bodyFormData.append("orderNumber", emailOrderNumber.value);
        if (emailOrderDeliveryDate.value)
            bodyFormData.append("orderDeliveryDate", emailOrderDeliveryDate.value);
    }

    let url = "email?language=" + ui.language;
    let emailSent: boolean | null = null;

    await axios.post<boolean>(
        url,
        bodyFormData,
        { headers: {'Content-Type': 'multipart/form-data' } }
    ).then(response => {
        emailSent = response.data;
        sendingEmail.value = false;

        if (!response.data) {
            errorSendingEmail.value = true;
        }
        else {
            emailSenderName.value = null;
            emailRecipient.value = null;
            emailMessage.value = null;
        }

        event("email", {
            "event_category": "DesignerAction",
            "event_label": cart.planCode,
            "value": 1
        });

        // if ($ga) {
        //     $ga.event({
        //         eventCategory: 'DesignerAction',
        //         eventAction: 'email',
        //         eventLabel: cart.planCode,
        //         eventValue: 1
        //     });
        // }
    }
    ).catch(error => {
        sendingEmail.value = false;

        //Sending emails is being throttled
        if (error.response.status == 409) {
            sendingEmailThrottled.value = true;
        }
        else {
            errorSendingEmail.value = true;
        }
    });
}

function getCodePart(length: number, title: string): string {
    let baseString = title + ": ";

    if (cart.currentDesignerCode.length < codeIndex.value + length)
        return baseString + "--";

    let ret = baseString + cart.currentDesignerCode.substring(codeIndex.value, codeIndex.value + length) + " [" + (codeIndex.value + 1 )+ " - " + (codeIndex.value + length) + "]";

    codeIndex.value = codeIndex.value + length;

    return ret;
}

const codeSummary = computed(() => {
    let parts = [];

    codeIndex.value = 0;

    parts.push(getCodePart(1, "Allas"));
    parts.push(getCodePart(4, "Kannen pituus"));
    parts.push(getCodePart(1, "Kannen korkeus"));
    parts.push(getCodePart(1, "Kätisyys"));
    parts.push(getCodePart(1, "Reunaprofiili"));
    parts.push(getCodePart(4, "S-mitta"));
    parts.push(getCodePart(1, "Kannen leveys"));
    parts.push(getCodePart(1, "Hanareikä"));
    parts.push(getCodePart(1, "Lisäreikä"));
    parts.push(getCodePart(1, "Materiaali"));

    parts.push(getCodePart(1, "Vesilukko"));

    parts.push(getCodePart(1, "Liesiaukko"));
    parts.push(getCodePart(4, "Liesiaukon pituus"));
    parts.push(getCodePart(3, "Liesiaukon leveys"));

    parts.push(getCodePart(1, "Liesiaukon nurkan säde"));
    parts.push(getCodePart(4, "Liesiaukon sijainti x"));
    parts.push(getCodePart(2, "Liesiaukon sijainti y"));

    parts.push(getCodePart(1, "M1 rakenne"));

    parts.push(getCodePart(2, "Grafiikka"));

    parts.push("Lisävarusteet: " + state.accessories);

    codeIndex.value = 0;

    return parts;
});

await mounted();

onBeforeRouteLeave(async () => {
    if (window.parent?.postMessage)
        await window.parent.postMessage({
            type: "codeInvalidated"
        }, "*")
})

</script>

